export class CacheProvider {
  constructor(CacheFactoryProvider) {
    'ngInject';
    this.CacheFactoryProvider = CacheFactoryProvider;
  }

  extend(options) {
    angular.extend(this.CacheFactoryProvider.defaults, options);
  }

  set(key, value) {
    angular.extend(this.CacheFactoryProvider.defaults, { [key]: value });
  }

  $get() {
    'ngInject';
    const { extend, set } = this;

    return {
      extend,
      set
    };
  }
}
